import React from 'react';
import Aboutbox from "./Aboutbox.js";

export default function About(){
  return (
   <div className="wrapper" id="about">
      <div className="container">
         <div className="row about-row">
            <Aboutbox
               title={"Introduction"}
               text={"I did my graduation from University of Engineering & Technology. I develop software for fun & profit. I started freelancing during my studies at University. Most of the work was related to Web & Android Applications development. After completion of degree I started career as a Web Developer. I love to read books & learning new things." }
               boxPosition={"0px"}
            />

            <div className='col-md-4 col-xs-12'>
               <div className="box-wrapper about" style={{marginTop: '50px'}}>
               <h3>Current Status</h3>
               <p>Working as a Full Stack RoR developer at <a href='https://finology.com.my/' className="company-name" target='_blank'>Finology</a>.It was one of the best professional experiences to work with skilled & professional people. Worked on the state of the art technologies, tools and writing gem. Gem writing from scratch was really amazing with use of Meta-programming and defining the structure.</p>
               </div>
            </div>

            <div className='col-md-4 col-xs-12'>
               <div className="box-wrapper about" style={{marginTop: '0px'}}>
               <h3>Professional Career</h3>
               <p>I started my professional career during the last year of graduation, when I got an offer of part time Job based on performance in Internship at <a href='https://aldaimsolutions.com/' className="company-name" target='_blank'>Aldaim Solutions</a>. later after graduation I joined <a href='https://www.netsolpk.com/' className="company-name" target='_blank'>NETSOL technologies</a> core development team. By the time did a career switch and join a startup <a href='https://evoke.team/' className="company-name" target='_blank'>Evoke Team</a>.</p>
               </div>
            </div>
         </div>
      </div>
   </div>
   )
  
}